'use client';

import { ReactElement } from 'react';
import { CLIENT_ORG_COMPONENTS } from '@provider-directory/app/lib/client-org-component';
import { useOrgContext } from '../org-context/org-context-provider';
import { TopBanner } from '../top-banner/top-banner';
import DefaultHeader from './default-header.component';

export interface HeaderProps {
  className?: string;
}

const Header = ({ className }: HeaderProps): ReactElement => {
  const { key } = useOrgContext();
  const HeaderContent =
    CLIENT_ORG_COMPONENTS[key]?.headerContent ?? DefaultHeader;

  return (
    <>
      <TopBanner />
      <HeaderContent className={className} />
    </>
  );
};

export default Header;
